import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Mega Pack después de comprar?',
  a: 'Recibirás el acceso al material de forma inmediata para que puedas empezar a usarlo cuanto antes, sin esperas ni trámites. Todo en formato PDF listo para descargar.'
}, {
  q: '¿Para qué nivel educativo está pensado?',
  a: 'Está diseñado principalmente para docentes de educación técnica agropecuaria de nivel secundario, aunque también es muy útil para formación docente, institutos agrarios y educación rural de nivel terciario.'
}, {
  q: '¿Sirve para cualquier país hispanohablante?',
  a: 'Sí. El material está desarrollado con referencias a toda América Latina: Argentina, Colombia, México, Perú, Paraguay, Uruguay, Ecuador, Venezuela, Bolivia, Chile y más. Incluye calendarios agrícolas y ejemplos por región.'
}, {
  q: '¿El material es editable?',
  a: 'El material se entrega en formato PDF de alta calidad, listo para usar directamente o imprimir. Es un material terminado y profesional, no un borrador para adaptar.'
}, {
  q: '¿En qué moneda voy a pagar?',
  a: 'Pagás en tu moneda local. El importe se adapta automáticamente al país desde donde comprás, a través de un procesador de pago seguro e internacional.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés 7 días de garantía total. Si el material no cumple lo que prometemos, te devolvemos el 100% de tu inversión. Sin preguntas. Sin formularios. Sin complicaciones.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-white" data-id="element-79" data-mp="wxw4aw103lg2">
      <div className="max-w-3xl mx-auto" data-id="element-80" data-mp="wynpdcwz20s3">
        <div className="text-center mb-16" data-id="element-81" data-mp="iymr8583d7gb">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-slate-900" data-id="element-82" data-mp="izo2a9p3xty1">
            ❓ Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-83" data-mp="2pmn4fvgnvtzm">
          {faqs.map((faq, index) => <div key={index} className="bg-cream border border-earth/20 rounded-xl overflow-hidden shadow-sm" data-id="element-84" data-mp="2poq291o22rew" data-mpi={index}>
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85" data-mp="2fw2ailbxndn1">
                <span className="font-bold text-lg text-slate-900 pr-8" data-id="element-86" data-mp="38kzfxnv1pfyd">
                  {faq.q}
                </span>
                <ChevronDown className={`text-forest transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-87" data-mp="33kbs1b245f8d" />
              </button>

              <AnimatePresence data-id="element-88" data-mp="2uo2p3mexfyhh">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-89" data-mp="1n9prr0kjrkov">
                    <div className="px-6 pb-5 text-slate-700 border-t border-earth/10 pt-4" data-id="element-90" data-mp="ch8eptgfdhk1">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}